<template>
  <div>
    <el-row class="searchSection">
      <el-form ref="form" :inline="true" :model="searcheModel">
        <el-form-item label="客户名称" class="customer-input">
          <CustomerSelect
            ref="CustomerSelect"
            :customerIdss="searcheModel.name"
            v-model="searcheModel.name"
            @change="CustomerHandleChange"
          ></CustomerSelect>
        </el-form-item>
        <DistrictLinkage
          ref="DistrictLinkage"
          :provinceId="searcheModel.province_id"
          :cityId="searcheModel.city_id"
          :districtId="searcheModel.district_id"
          @change="handleChange($event)"
        ></DistrictLinkage>
        <el-form-item label="客户创建时间">
          <el-date-picker
            size="small"
            v-model="searcheModel.create_times"
            type="daterange"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" @click="submitSearch"
            >搜索</el-button
          >
          <el-button @click="resetForm()" size="small">重置</el-button>
        </el-form-item>
      </el-form>
    </el-row>
    <el-row>
      <el-table :data="list" border v-loading="loading">
        <el-table-column prop="id" label="ID"></el-table-column>
        <el-table-column prop="name" label="客户名称"></el-table-column>
        <el-table-column prop="sales_leads_id" label="删除原因">
            <template slot-scope="scope">
                {{scope.row.delete_log.memo}}
            </template>
        </el-table-column>
        <el-table-column prop="operator_name" label="删除时间">
            <template slot-scope="scope">
                {{scope.row.delete_log.created_at}}
            </template>
        </el-table-column>
        <el-table-column prop="flag_name" label="操作人">
            <template slot-scope="scope">
                {{scope.row.delete_log.operator_name}}
            </template>
        </el-table-column>
        <el-table-column
          prop="created_at"
          label="客户创建时间"
        ></el-table-column>
        <el-table-column
          prop="district_names"
          label="所在地区"
        ></el-table-column>
        <el-table-column label="操作" fixed="right">
          <template slot-scope="scope">
            <el-button @click="handleView(scope.row)" type="text" size="small">查看</el-button>
            <el-button
              type="text"
              size="small"
              @click="showRevertDialog(scope.row)" v-if="Acs('/customers/revert')">恢复</el-button>
          </template>
        </el-table-column>
      </el-table>
      <MyPagination :linkPage="linkPage" @size-change="handleSizeChange" @current-change="handleCurrentChange"></MyPagination>
    </el-row>
  </div>
</template>
<style scoped>

</style>
<script>
import CustomerService from "~/services/customer";
import DistrictLinkage from "~/widgets/DistrictLinkage.vue";
import CustomerSelect from "~/widgets/CustomerSelect.vue";
import MyPagination from "~/widgets/MyPagination.vue";
export default {
  name: "recycle",

  components: {
    DistrictLinkage,
    CustomerSelect,
    MyPagination
  },

  props: {},

  data() {
    return {
      loading: false,
      searcheModel: {
        name: "",
        province_id: 0,
        city_id: 0,
        district_id: 0,
        create_times: [],
      },
      // 分页信息
      linkPage: null,
      list: [],
    };
  },

  mounted() {},

  created: function () {
    this.getList(this.searcheModel);
  },

  methods: {
    //重置按钮
    resetForm() {
      this.searcheModel = {
        name: "",
        province_id: 0,
        city_id: 0,
        district_id: 0,
        create_times: [],
      };
      this.$refs['CustomerSelect'].reset();
      this.list = [];
      this.submitSearch();
    },

    // 筛选查询
    submitSearch() {
      this.getList(this.searcheModel);
    },

    //获取列表
    getList(params) {
        // loading 动画
        this.loading = true;
        CustomerService.getRecycleList(params).then((res) => {
            if (res.code == 0) {
                this.list = res.data;
            }
            if (res._meta) {
                this.linkPage = res._meta;
            }
            this.loading = false;
        }).catch((err) => {
            console.error(err);
            this.loading = false;
        });
    },

    //客户名称远程搜索组件赋值
    CustomerHandleChange(object) {
      this.searcheModel.name = object.value;
    },

    handleSizeChange(newSize) {
      // 处理每页条目数变化事件
      let params = this.searcheModel;
      params["perPage"] = newSize;
      this.getList(params);
    },

    handleCurrentChange(newPage) {
      let params = this.searcheModel;
      // 处理当前页码变化事件
      params["page"] = newPage;
      this.getList(params);
    },

    handleView(customer) {
        let routeData = this.$router.resolve({
            path: "/customers/view",
            query: { id: customer.id },
        });
        window.open(routeData.href, '_blank');
    },

    //删除客户的提示和数据处理。
    showRevertDialog(customer) {
        this.$confirm("确认将客户恢复到客户公海池？", "温馨提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
            center: true
        }).then(() => {
            this.handleRevert([customer.id]);
        }).catch((err) => {
            console.error(err);
        });
    },

    //删除客户
    handleRevert(ids) {
        CustomerService.revert({customer_ids: ids}).then(res => {
            if(res.code == 0){
                this.$message({
                    message: '恢复成功',
                    type: 'success'
                });
                this.submitSearch();
            }else{
                this.$message({
                    message: res.msg,
                    type: 'error'
                });
            }
        }).catch((err) => {
            console.error(err);
        });
    },

    //地区联动 Cascader 级联选择器,切换事件,表单model赋值
    handleChange(value) {
        this.searcheModel.province_id = parseInt(value[0]);
        this.searcheModel.city_id = parseInt(value[1]);
        this.searcheModel.district_id = parseInt(value[2]);
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/views/customer/recycle.vue